<!--content profilo-->
<div class="container mt-5 px-lg-0">
	<div class="row no-gutters flex-row-reverse">
		<div class="col-lg-12 mt-5">
			<p class="font-16">
				Welcome
				<span>{{user.username}}</span>
				,
			</p>
			<div class="d-flex font-12 align-items-center">
				<p class="mb-0 mr-2">
					Aren't you
					<span>{{user.username}}</span>
				</p>
				<a class="text-underline pb-0 font-italic" [routerLink]="'/logout'">Click here to logout</a>
			</div>
		</div>
		<div class="col-lg-3">
			<div class="col-12 col-md-6 col-lg-12 px-0 mt-5 mt-lg-0">
				<div class="border p-3">
					<h6>Change Password:</h6>
					<form #form="ngForm">
						<input
							class="rounded-0 form-bertazzoni white mt-3 w-100"
							type="password"
							placeholder="OLD PASSWORD*"
							[(ngModel)]="jsonIn.oldPassword"
							name="oldPassword" />
						<input
							class="rounded-0 form-bertazzoni white mt-3 w-100"
							type="password"
							placeholder="NEW PASSWORD*"
							[(ngModel)]="jsonIn.newPassword"
							name="newPassword" />
						<input
							class="rounded-0 form-bertazzoni white mt-3 w-100"
							type="password"
							placeholder="REPEAT PASSWORD*"
							[(ngModel)]="jsonIn.newPasswordRepeat"
							name="newPasswordRepeat" />
						<p class="my-2" *ngIf="error" [innerHTML]="error"></p>
						<button
							type="button"
							class="btn btn-bertazzoni black btn-block rounded-0 py-2 mt-3"
							(click)="cambioPassword()"
							[disabled]="form.invalid">
							OK
						</button>
					</form>
				</div>
			</div>
		</div>
		<div class="col-lg-9 mt-5">
			<h4 class="mb-4">Summary of my data:</h4>
			<div class="my-4 d-lg-flex">
				<div class="pr-3 border-right">
					<span class="font-semibold pr-2">Username:</span>
					<span>{{user.username}}</span>
				</div>
				<div class="px-lg-3 border-right">
					<span class="font-semibold pr-2">Email:</span>
					<span>{{user.email}}</span>
				</div>
				<div class="px-lg-3 border-right">
					<span class="font-semibold pr-2">Company:</span>
					<span>{{user.cliente?.ragioneSociale | titlecase}}</span>
				</div>
			</div>

			<div class="my-4">
				<span class="font-semibold pr-2">Billing address:</span>
				<span>{{user.cliente?.indirizzo | titlecase}}&nbsp;{{user.cliente?.localita | titlecase}}</span>
			</div>
			<div class="my-5 font-12">
				<span>Do you need to change your data? Lost your password?</span>
				<span><a class="ml-2 text-underline font-italic">Contact the Bertazzoni Service Center.</a></span>
			</div>

			<h4>Summary of shipping addresses:</h4>
			<div class="my-4" *ngFor="let indirizzo of indirizzi, let i = index">
				<span class="font-semibold pr-2">
					SHIPPING ADDRESS
					<span>{{i+1}}</span>
					:
				</span>
				<span>{{indirizzo.indirizzo | titlecase}}&nbsp;{{indirizzo.localita | titlecase}}</span>
			</div>

			<div class="my-5 font-12">
				<span>Do you need to change or add a shipping address?</span>
				<span><a class="ml-2 text-underline font-italic">Contact Bertazzoni.</a></span>
			</div>
		</div>
	</div>
</div>
